/* eslint-disable no-param-reassign */
/* eslint-disable no-undef */
import React, { useEffect } from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import AOS from 'aos';
import 'aos/dist/aos.css';
// import Img from 'gatsby-image';

const GeneralContent = ({ content, backUp }) => {
  useEffect(() => {
    const galleryItems = document.querySelectorAll('.gallery-item');
    const figures = document.querySelectorAll('figure:not(.gallery-item) .gatsby-image-wrapper');
    if (galleryItems) {
      galleryItems.forEach((item) => {
        item.dataset.aos = 'fade-up';
        item.dataset.aosOffset = '200';
      });
      if (figures) {
        figures.forEach((figure) => {
          const figParent = figure.closest('figure');
          const figCaption = figParent.querySelector('figcaption');
          figure.dataset.aos = 'fade-up';
          figure.dataset.aosOffset = '200';
          if (figCaption) {
            figCaption.dataset.aos = 'fade-up';
          }
        });
      }
      AOS.init();
    }
  });
  return (
    <>
      {backUp ? <Link className="return return--top" to="../">Go Back</Link> : false}
      {content ? <div className="general-content">{parse(content)}</div> : ''}
      {backUp ? <Link className="return return--bottom" to="../">Go Back</Link> : false}
    </>
  );
};

GeneralContent.propTypes = {
  content: PropTypes.string,
  backUp: PropTypes.bool,
};
GeneralContent.defaultProps = {
  content: '',
  backUp: false
};
export default GeneralContent;
